import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { getSearchUrl } from '../../search/searchRouting.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistNotFound = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlists.notFound.title"
    }),
    type: "notFound",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.notFound.description"
      })
    }), /*#__PURE__*/_jsx(ACRouterLink, {
      to: getSearchUrl({
        contentType: 'LEARNING_PATH'
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.notFound.link"
      })
    })]
  });
};
export default PlaylistNotFound;